export const IntegrationLabelTypes = Object.freeze({
  softGreen: 'softgreen',
  green: 'green',
  grey: 'grey',
  blue: 'blue',
  yellow: 'yellow',
  white: 'white'
})
